/**
 * Class on the body element that prevents scrolling.
 */
import { currentBreakpoint } from './resize.utils';

const stopScrollingClassName = 'no-scroll';
const stopScrollingClassNameMobile = 'no-scroll-mobile';

/**
 * Prevent scrolling on body.
 */
export const preventScrollingOnBody = (mobileOnly = false): void => {
  if (mobileOnly) {
    document.documentElement.classList.add('no-scroll-mobile');
  } else {
    document.documentElement.classList.add(stopScrollingClassName);
    document.documentElement.dataset.preventScroll = 'true';
  }
};

/**
 * Allow scrolling on body.
 */
export const allowScrollingOnBody = (mobileOnly = false): void => {
  if (mobileOnly) {
    document.documentElement.classList.remove('no-scroll-mobile');
  } else {
    document.documentElement.classList.remove(stopScrollingClassName);
    document.documentElement.removeAttribute('data-prevent-scroll');
  }
};

/**
 * Checks if scrolling is currently allowed on the body.
 */
export const isScrollingAllowed = (): boolean => {
  const breakpoint = currentBreakpoint();
  return !(
    document.documentElement.dataset.preventScroll === 'true' ||
    (breakpoint.isMobileAny && document.documentElement.classList.contains(stopScrollingClassNameMobile))
  );
};
